import { Component, Inject } from '@angular/core';
import { DialogSize } from '@aiwyn/shared';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PaymentActionRequirementDialogData {
  header: string;
}

@Component({
  selector: 'app-payment-action-requirement-dialog',
  templateUrl: './payment-action-requirement-dialog.component.html',
  standalone: false,
})
export class PaymentActionRequirementDialogComponent {
  readonly DialogSize = DialogSize;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: PaymentActionRequirementDialogData,
    private readonly dialogRef: MatDialogRef<PaymentActionRequirementDialogComponent, PaymentActionRequirementDialogData>,
  ) {
    this.dialogRef.disableClose = true;
  }
}
